import { ComponentType, SVGProps } from 'react';
import { ArrowRightIcon } from '@zep-us/zus';
import Link from 'next/link';
import { Trans, useTranslation } from 'next-i18next';
import { cn } from '@zep/utils';
import { serviceShortcuts } from '../../../../consts/landingConsts';
interface ShortcutCardProps {
  LogoComponent?: ComponentType<SVGProps<SVGSVGElement>>;
  title: (typeof serviceShortcuts)[number]['title'];
  url: string;
  imageUrl: string;
  gradientFrom: string;
  gradientTo: string;
}
export const ShortcutCard = ({
  LogoComponent,
  title,
  url,
  imageUrl,
  gradientFrom,
  gradientTo
}: ShortcutCardProps) => {
  const {
    t
  } = useTranslation(['home']);
  return <Link href={url} className={cn('block w-full max-w-[400px] tablet:max-w-[410px]', 'bg-gradient-to-b', 'border border-quiz-opacity-black-4 rounded-quiz-lg lg:rounded-quiz-2xl', 'overflow-hidden', 'transition-transform duration-200', 'hover:scale-[1.02]', 'max-h-[394px] tablet:max-h-[468px] lg:max-h-[548px]', gradientFrom, gradientTo)} data-sentry-element="Link" data-sentry-component="ShortcutCard" data-sentry-source-file="ShortcutCard.tsx">
      <div className="flex h-full flex-col">
        <div className={cn('grid grid-cols-[auto_1fr] gap-x-quiz-sm gap-y-quiz-sm tablet:gap-y-quiz-lg', 'pt-quiz-xl px-quiz-xl pb-quiz-sm tablet:pb-quiz-md lg:pt-quiz-2xl lg:px-quiz-2xl', 'shrink-0')}>
          {LogoComponent && <div className="col-start-1 row-start-1 w-auto">
              <LogoComponent className="h-[24px] w-auto tablet:h-[34px] lg:h-[40px]" />
            </div>}
          <div className="col-start-2 row-start-1 flex h-[32px] items-center gap-[4px] justify-self-end tablet:col-start-1 tablet:row-start-3 tablet:justify-self-start">
            <span className="text-quiz-body-md-medium text-quiz-gray-900 tablet:text-quiz-body-lg-semibold">
              {t('home:landing.shortcut.link')}
            </span>
            <ArrowRightIcon className="size-[16px] text-quiz-gray-900" data-sentry-element="ArrowRightIcon" data-sentry-source-file="ShortcutCard.tsx" />
          </div>
          <h3 className="col-span-2 col-start-1 row-start-2 text-quiz-heading-md-bold text-quiz-gray-900 tablet:col-span-1 tablet:col-start-1 lg:text-quiz-heading-xl-extrabold">
            <Trans t={t} i18nKey={title} components={{
            br: <br className="hidden lg:inline" />
          }} data-sentry-element="Trans" data-sentry-source-file="ShortcutCard.tsx" />
          </h3>
        </div>

        <div className="min-h-0 w-full flex-1 overflow-hidden">
          <img src={imageUrl} alt={t(title)} className="size-full object-cover object-top" loading="lazy" />
        </div>
      </div>
    </Link>;
};